import { TimelineBoApproval } from '../../model/divestment/TimelineBoApproval';
import { TimelineNboApproval } from '../../model/divestment/TimelineNboApproval';

export const TimelineFormCtrlSuffix = {
  na: '-na',
  complete: '-complete',
  date: '-date',
};
export const TimelineNboApprovalToLabel = {
  [TimelineNboApproval.D_NBO_DP_N1]: 'D-NBO-DP-N1',
  [TimelineNboApproval.D_NBO_DP_N2]: 'D-NBO-DP-N2',
  [TimelineNboApproval.D_NBO_G_OPEA]: 'D-NBO-G-OPEA',
};
export const TimelineNboApprovalToTooltip = {
  [TimelineNboApproval.D_NBO_DP_N1]:
    'Divestment – Non-Binding Offer – Decision Proposal – Onshore: ≥€25m to <€50m (N-1); Solar: ≥€25m to <€50m (N-1); Storage: ≥€25m to <€50m (N-1)',
  [TimelineNboApproval.D_NBO_DP_N2]:
    'Divestment – Non-Binding Offer – Decision Proposal – Onshore: <€25m (N-2); Solar: <€25m (N-2); Storage: <€25m (N-2)',
  [TimelineNboApproval.D_NBO_G_OPEA]:
    'Divestment – Non-Binding Offer – Gate – Onshore: ≥€50m (RWE OPEA Board); Solar: ≥€50m (RWE OPEA Board); Storage: ≥€50m (RWE OPEA Board)',
};
export const TimelineBoApprovalToLabel = {
  [TimelineBoApproval.D_BO_DP_N1]: 'D-BO-DP-N1',
  [TimelineBoApproval.D_BO_DP_N2]: 'D-BO-DP-N2',
  [TimelineBoApproval.D_BO_G_OPEA]: 'D-BO-G-OPEA',
};
export const TimelineBoApprovalToTooltip = {
  [TimelineBoApproval.D_BO_DP_N1]:
    'Divestment – Binding Offer – Decision Proposal – Onshore: ≥€10m to <€20m (N-1); Solar: ≥€10m to <€20m (N-1); Storage: ≥€10m to <€20m (N-1)',
  [TimelineBoApproval.D_BO_DP_N2]:
    'Divestment – Binding Offer – Decision Proposal – Onshore: <€10m (N-2); Solar: <€10m (N-2); Storage: <€10m (N-2)',
  [TimelineBoApproval.D_BO_G_OPEA]:
    'Divestment – Binding Offer – Gate – Onshore: ≥€20m (RWE OPEA Board); Solar: ≥€20m (RWE OPEA Board); Storage: ≥€20m (RWE OPEA Board)',
};
